<template>
	<v-container fill-height fluid class="pa-0">
		<AlterarSenha :mostrar="abrirAlterarSenha" @fecharAlterarSenha="fechar()"/>
		<v-card class="mx-auto col-10 col-lg-4">
			<v-list>
				<v-list-item-group>
					<v-list-item>
						<h2>Alterar senha:</h2>
						<v-spacer></v-spacer>
						<v-list-item-action>
							<v-btn small color="primary my-4" @click="alterarSenha()">Nova Senha</v-btn>
						</v-list-item-action>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-card>
	</v-container>
</template>

<script>
	
	import AlterarSenha from '@/components/preferencias/AlterarSenha'
	
	export default{
		name: 'Preferencias',
		components: {AlterarSenha},
		computed:{
		},
		data(){
			return{
				abrirAlterarSenha: false,
			}
		},
		methods:{
			alterarSenha(){
				this.abrirAlterarSenha = true
			},
			

			fechar(){
				this.abrirAlterarSenha = false
				this.senhas = {}
			}
		}
	}

</script>

<style scoped>

</style>